import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { getExportReports } from "@/utils/apis/doctor/report";

import { RootState } from "@/store/store";
import dayjs from "dayjs";

export const fetchExportReport = createAsyncThunk(
  "fetchExportReport/fetch",
  async ({
    endpoint,
    dateRange,
  }: {
    endpoint: string;
    dateRange?: { startDate: string; endDate: string };
  }) => {
    let finalDateRange = dateRange;
    if (dateRange?.startDate && dateRange?.endDate) {
      finalDateRange = {
        ...dateRange,
        endDate: dayjs(dateRange.endDate).add(1, "day").format("YYYY-MM-DD"),
      };
    }

    const response = await getExportReports(endpoint, finalDateRange);
    return response;
  }
);

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const exportReportSlice = createSlice({
  name: "medicalPartnerReport",
  initialState,
  reducers: {
    resetReport: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExportReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchExportReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchExportReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch report";
      });
  },
});

const selectExportReport = (state: RootState) => state.staffReport;

export const exportReportSelector = createSelector(
  [selectExportReport],
  (exportReport) => ({
    data: exportReport.data,
    status: exportReport.status,
    error: exportReport.error,
  })
);

export const { resetReport } = exportReportSlice.actions;

export default exportReportSlice.reducer;
